var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 314,
    viewBox: "0 0 106 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.12012 51.7545C1.12012 23.2153 24.3704 -2.49507e-06 52.9526 0C81.5352 2.49501e-06 104.786 23.2154 104.786 51.7545C104.786 80.2942 81.5352 103.51 52.9526 103.51C24.3704 103.51 1.12011 80.2887 1.12012 51.7545Z",
    fill: "#B1D12B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.362061 208.115L0.36207 104.767H105.538L105.537 208.115H0.362061Z",
    fill: "#7B60A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.376 208.644V314H0L0.0111545 309.989C0.167165 245.316 34.2208 211.27 101.225 208.794L105.376 208.644Z",
    fill: "#F69E89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 314,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRectangle);
export default __webpack_public_path__ + "static/media/circle-rectangle.33ff21298875b96cfc000c716786e07f.svg";
export { ForwardRef as ReactComponent };